import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { withPage } from '../../components/Page';
import { PrototypeBar } from '../../components/PrototypeBar';
import styles from './MobileAsset.module.scss';

const MobileAsset: FC = () => {
  const navigate = useNavigate();

  return (
    <main className={styles.container} tabIndex={-1}>
      <PrototypeBar />

      <div className={styles.mobileStage}>
        <div className={styles.mobileCopy}>
          <div className={styles.eyebrow}>Mobile / QR scan entry point</div>
          <h2>Immediate, useful information at the equipment.</h2>
          <p>
            After the engineer scans the physical Pulse label, the asset opens directly with the documents and actions that matter most on site.
          </p>
          <div className={styles.flow}>
            <b>Scan label</b> → <b>Open asset</b> → <b>Take action</b>
          </div>
          <div style={{ marginTop: '2.4rem' }}>
            <button
              type="button"
              className={styles.primaryBtn}
              onClick={() => navigate('/contextual-ai')}
            >
              ✦ Test Contextual Ask AI (Screen 05)
            </button>
          </div>
        </div>

        <div className={styles.phone}>
          <div className={styles.phoneTop}>
            <span>9:41</span>
            <span>● ● ●</span>
          </div>
          <div className={styles.phoneContent}>
            <span className={styles.scanPill}>✓ Opened from Pulse Asset QR</span>
            <h1>AHU-003</h1>
            <p className={styles.phoneSub}>Air Handling Unit · Plant Room 01</p>
            <span className={styles.status}>
              <span className={styles.dot} />
              Operational
            </span>

            <div className={styles.mobileCard}>
              <h3>Key information</h3>
              <div className={styles.mobileInfo}>
                <div>
                  <span>Manufacturer</span>
                  <b>Trane</b>
                </div>
                <div>
                  <span>Model</span>
                  <b>CCU-240</b>
                </div>
                <div>
                  <span>Serial number</span>
                  <b>SN784563</b>
                </div>
                <div>
                  <span>Next service</span>
                  <b>14 Oct 2026</b>
                </div>
              </div>
            </div>

            <div className={styles.mobileCard}>
              <h3>Quick access</h3>
              <div className={styles.quick}>
                <a href="/more-info" style={{ display: 'flex', flexDirection: 'column', color: 'inherit', textDecoration: 'none', background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-sm)', padding: '0.8rem 1rem', fontSize: '1.25rem', fontWeight: 600 }}>
                  ▤ O&amp;M manual
                  <span style={{ fontSize: '1.1rem', fontWeight: 400, color: 'var(--color-text-secondary)' }}>4.2 MB · PDF</span>
                </a>
                <a href="/more-info" style={{ display: 'flex', flexDirection: 'column', color: 'inherit', textDecoration: 'none', background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-sm)', padding: '0.8rem 1rem', fontSize: '1.25rem', fontWeight: 600 }}>
                  ✓ Maintenance
                  <span style={{ fontSize: '1.1rem', fontWeight: 400, color: 'var(--color-text-secondary)' }}>Next task in 23 days</span>
                </a>
                <a href="/more-info" style={{ display: 'flex', flexDirection: 'column', color: 'inherit', textDecoration: 'none', background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-sm)', padding: '0.8rem 1rem', fontSize: '1.25rem', fontWeight: 600 }}>
                  ⌗ Drawings
                  <span style={{ fontSize: '1.1rem', fontWeight: 400, color: 'var(--color-text-secondary)' }}>2 related drawings</span>
                </a>
                <a href="/more-info" style={{ display: 'flex', flexDirection: 'column', color: 'inherit', textDecoration: 'none', background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-sm)', padding: '0.8rem 1rem', fontSize: '1.25rem', fontWeight: 600 }}>
                  ▣ Certificates
                  <span style={{ fontSize: '1.1rem', fontWeight: 400, color: 'var(--color-text-secondary)' }}>1 active certificate</span>
                </a>
              </div>
            </div>

            <div className={styles.mobileCard}>
              <h3>Need help with this asset?</h3>
              <button
                type="button"
                className={styles.primaryBtn}
                style={{ width: '100%', height: '3.8rem', fontSize: '1.3rem' }}
                onClick={() => navigate('/contextual-ai')}
              >
                ✦ Ask AI about AHU-003
              </button>
            </div>
          </div>

          <div className={styles.mobileNav}>
            <span>⌂<br />Home</span>
            <span>⌕<br />Search</span>
            <b style={{ color: '#007f85' }}>▦<br />Scan</b>
            <span>▤<br />Documents</span>
            <span>☰<br />More</span>
          </div>
        </div>
      </div>
    </main>
  );
};

export default withPage(MobileAsset)({
  meta: {
    title: 'Mobile Asset Scan View — AHU-003 · Pulse',
    description: 'Mobile QR scan entry point for AHU-003.',
  },
  breadcrumbs: [
    { label: 'Pulse', href: '/' },
    { label: 'Commerzbank', href: '/' },
    { label: 'Mobile asset', href: '/mobile-asset' },
  ],
});
